import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAttach = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.2909 7.77449L8.16426 13.9012C7.41369 14.6517 6.39571 15.0734 5.33426 15.0734C4.2728 15.0734 3.25482 14.6517 2.50426 13.9012C1.75369 13.1506 1.33203 12.1326 1.33203 11.0712C1.33203 10.0097 1.75369 8.99172 2.50426 8.24116L8.63092 2.11449C9.1313 1.61412 9.80995 1.33301 10.5176 1.33301C11.2252 1.33301 11.9039 1.61412 12.4043 2.11449C12.9046 2.61487 13.1857 3.29352 13.1857 4.00116C13.1857 4.70879 12.9046 5.38745 12.4043 5.88782L6.27092 12.0145C6.14704 12.1384 5.99998 12.2366 5.83812 12.3037C5.67626 12.3707 5.50278 12.4052 5.32759 12.4052C5.1524 12.4052 4.97892 12.3707 4.81706 12.3037C4.6552 12.2366 4.50814 12.1384 4.38426 12.0145C4.26038 11.8906 4.16211 11.7435 4.09506 11.5817C4.02802 11.4198 3.99351 11.2464 3.99351 11.0712C3.99351 10.896 4.02802 10.7225 4.09506 10.5606C4.16211 10.3988 4.26038 10.2517 4.38426 10.1278L10.0443 4.47449",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAttach;
